import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import app from './firebase.init';
import isValidEmail from "../../utils/isValidEmail";
// import isValidPassword from "../../utils/isValidPassword";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const ForgotPassword = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    const auth = getAuth(app);
    const onSubmit = data => {
        const email = data.email;
        if (!isValidEmail(email)) {
            return toast.error("Email is not valid", {
                position: "bottom-left",
            });
        }
        else {
            sendPasswordResetEmail(auth, email)
                .then(() => {
                    toast.success("mail send", {
                        position: "bottom-left",
                    });
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    toast.error("Erorr", {
                        position: "bottom-left",
                    });
                });
        }
    };

    return (
        <div className='py-5 bg-gray-200'>
            <div className="container mx-auto md:px-5">
                <div className="bg-white md:p-5">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <p className='text-gray-800 pb-4 font-poppins'>{translate ? "Enter your email address below and we’ll send you a link to reset your password" : "নীচে আপনার ইমেল ঠিকানা লিখুন এবং আমরা আপনার পাসওয়ার্ড পুনরায় সেট করার জন্য আপনাকে একটি লিঙ্ক পাঠাব৷"} </p>
                        <div className='mb-4'>
                            <label className="block text-sm font-normal text-gray-600 mb-0">
                                {translate ? "Email Address*" : "ইমেল ঠিকানা*"}
                            </label>
                            <input
                                type="email"
                                placeholder={translate ? "Please enter your Email" : "আপনার ইমেল ঠিকানা লিখুন দয়া করে"}
                                name="email"
                                {...register("email", { required: true })}
                                className="h-9 focus:outline-offset-2  outline-blue-500/50 text-gray-600 my-1 border border-gray-400 md:w-1/2 w-full py-3 px-2 focus:outline-none font-poppins"

                            />
                            {errors.email && <p className='text-red-600'>{translate ? "This field is required" : "ঘরটি অবশ্যই পূরণ করতে হবে"}</p>}
                        </div>
                        <button type="submit" className=" md:w-60 w-full py-2 odd:my-1.5 rounded text-white bg-bnd-1 font-poppins">{translate ? "SEND EMAIL" : "ইমেইল পাঠান"}</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;